import { Box } from "@mui/material";
import Heading from "./components/heading";
import Navbar from "./components/navbar";
import Index from "./components/fun";
import apnacricket from "./images/apnacricket.png";
import quiz from "./images/quiz.png";
import calci from "./images/calci.png";
import { useMediaQuery } from "@mui/material";
import { Fade } from "react-awesome-reveal";

const Fun = () => {
  const isNotMobile = useMediaQuery("(min-width:1024px)");
  return (
    <Box>
      <Heading name="JustForFun" />

      <Box
        display="grid"
        gridTemplateColumns={isNotMobile ? "repeat(3,1fr)" : "repeat(1,ifr)"}
        gap="2rem"
        maxWidth={"80%"}
        ml="auto"
        mr="auto"
        mt="3rem"
        mb="10rem"
      >
        <Fade cascade damping={0.1}>
          <Index
            img={apnacricket}
            name="Play apna cricket"
            desc="Enjoy playing an exciting virtual cricket game."
            link="https://apna-cricket.netlify.app/"
          />

          <Index
            img={calci}
            name="calculator"
            desc="want to add something up?"
            link="https://calculator-style.netlify.app/"
          />

          <Index
            img={quiz}
            name="Fast-Paced Animated Quiz"
            desc="Fun timed quiz with animations and scoring."
            link="https://quiz-app-hazel-xi.vercel.app/"
          />

        </Fade>
      </Box>

      <Navbar prev="projects" next="contact" />
    </Box>
  );
};

export default Fun;
